<template>
  <div class="totalPie">
    <el-button class="xxbutton" type="primary" round size="medium" @click="xxClick">事件详细报告</el-button>
    <div class="tit">
      <p>事件降雨洪水统计表</p>
    </div>
    <el-table :data="tableData" stripe style="width: 96%;margin-left: 2%;margin-top: 1%;" height="85"
      empty-text="无数据">
      <!-- <el-table-column :formatter="order" label="序号" width="50"></el-table-column> -->
      <el-table-column prop="jytzz" label="降雨特征值"></el-table-column>
      <el-table-column prop="hstzz" label="洪水特征值"></el-table-column>
      <el-table-column prop="zd" label="最大24小时点雨量"></el-table-column>
      <el-table-column prop="dy" label="大于25毫米降雨面积"></el-table-column>
      <el-table-column prop="hfll" label="洪峰流量"></el-table-column>
      <el-table-column prop="chzl" label="次洪总量"></el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {} from "@/api/api.js";
  export default {
    data() {
      return {
        tableData: [{
          jytzz: 20,
          hstzz: 20,
          zd: 20,
          dy: 20,
          hfll: 20,
          chzl: 20
        }]
      };
    },
    mounted() {},
    computed: {},
    watch: {},
    methods: {
      xxClick() {
        this.$emit('xqData', '111')
      }
    },
  };
</script>

<style scoped>
  .totalPie {
    width: 100%;
    height: 100%;
    background: url(../../common/images/dialog.png) no-repeat center;
    background-size: 100% 100%;
  }
  .xxbutton {
    position: absolute;
    top: -40px;
    right: 0;
  }
  .content {
    width: 100%;
    height: 28%;
  }
  >>>.el-table {
    /* margin-top: 10px; */
    border-color: #0077AA;
    background-color: transparent !important;
  }

  >>>.el-table thead {
    background-color: rgba(0, 179, 254, 0.5) !important;
  }

  >>>.el-table .cell {
    text-align: center;
    /* font-size: 16px; */
    color: #eaeaea;
  }

  >>>.el-table th {
    background-color: transparent !important;
    border-color: #0077AA;
  }

  >>>.el-table tr {
    background-color: transparent !important;
  }

  >>>.el-table td,
  >>>.el-table th.is-leaf {
    border-color: #0077AA;
  }

  >>>.el-table__body tr:hover>td {
    background-color: rgba(0, 179, 254, 0.3) !important;
  }

  >>>.el-table--border::after,
  >>>.el-table--group::after,
  >>>.el-table::before {
    background-color: #0077AA;
  }

  >>>.el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: rgba(0, 179, 254, 0.1);
  }

  >>>.el-table td,
  .el-table th {
    padding: 6px 0;
  }

  >>>.el-tabs__item {
    color: #fff;
  }

  >>>.el-tabs__item.is-active {
    color: #409EFF;
  }
</style>
